import {  useState } from 'react';
import { getRequest } from 'services/api';

const useBankAccounts = () => {
    const [bankAccounts, setBankAccounts] = useState({
        loading: false,
        data: [],
    });

    const fetchBankAccounts = async () => {
        setBankAccounts((prevState) => ({
            ...prevState,
            loading: true,
        }));
        try {
            const response = await getRequest('/company-bank');
            if (response.success) {
                setBankAccounts({
                    loading: false,
                    data: response.data,
                });
            }
        } catch (error) {
            setBankAccounts((prevState) => ({
                ...prevState,
                loading: false,
            }));
        }
    };

    return {
        bankAccounts,
        fetchBankAccounts,
        setBankAccounts,
    };
};

export default useBankAccounts;